<div
  class="relative z-[2] mr-[0.4rem] flex h-[12.7rem] w-[14.6rem] flex-col items-start justify-end overflow-hidden rounded-[1.6rem] bg-[linear-gradient(180deg,rgba(255,225,159,0.21)_0%,rgba(255,225,159,0.60)_100%)] p-[1.2rem] custom-transition-bg before:bg-[linear-gradient(180deg,rgba(255,225,159,0.28)_0%,rgba(255,225,159,0.80)_100%)] lg:mr-[0.8rem] lg:h-[10.2rem] lg:w-[11.1rem] lg:rounded-[1.4rem] lg:p-[1rem]"
>
  <div
    class="absolute right-[0.9rem] top-[0.8rem] z-[2] flex min-w-[6.3rem] items-center justify-center rounded-[1.5rem] bg-[#F9F2A8] px-[0.7rem] py-[0.4rem] lg:right-[0.6rem] lg:top-[0.6rem] lg:h-[1.6rem] lg:min-w-[5.5rem] lg:px-[0.6rem] lg:py-[0.2rem]"
  >
    <div
      class="flex items-center justify-center text-[0.9rem] font-400 leading-[1.2rem] text-[#50432F] lg:text-[0.8rem] lg:leading-[1.2rem]"
    >
      @if (timerData().days[1]) {
          <span>{{ daysCounter(timerData().days[0]) }}</span>
        &nbsp;
      }
      <div>
        <span>{{ timerData().hours[0] }}</span> 
      </div>
      <span>:</span>
      <div>
        <span>{{ timerData().minutes[0] }}</span>
      </div>
      <span>:</span>
      <div>
        <span>{{ timerData().seconds[0] }}</span>
      </div>
    </div>
  </div>
  <img
    loading="lazy"
    fetchpriority="low"
    [ngClass]="gameMask()"
    class="pointer-events-none absolute left-1/2 top-[0.46rem] h-fit max-h-[7.4rem] w-[12.5rem] -translate-x-1/2 lg:top-[1rem] lg:w-[8rem]"
    [src]="raffle.prize.item.id | itemImage: 'large'"
    [alt]="raffle.prize.item.marketName"
  />
  <div class="z-[2] flex flex-col items-start justify-end space-y-[0.4rem] lg:space-y-[0.3rem]">
    <div class="flex flex-col items-start justify-end space-y-[0.2rem] lg:space-y-0">
      @if (isCsgoItem(raffle.prize.item)) {
        <span class="text-[1rem] font-bold leading-[1.2rem] text-[#413A29] lg:text-[0.9rem] lg:leading-[0.9rem]">{{
          raffle.prize.item.extra | itemExterior: raffle.prize.item.appId
        }}</span>
      }
      <span
        class="max-w-[12rem] truncate text-[1.2rem] font-medium leading-[1.6rem] text-black lg:max-w-[9rem] lg:text-[1rem] lg:leading-[1.4rem] ..."
      >
        {{ raffle.prize.item.marketName.split('|')[0] }}
      </span>
    </div>
    <div
      class="flex items-center justify-center space-x-[0.3rem] rounded-[2.4rem] bg-[#422911] p-[0.6rem] pr-[0.8rem] text-[1.1rem] font-400 leading-[1.4rem] text-[#FFDB95] lg:pb-[0.4rem] lg:pr-[0.7rem] lg:pt-[0.3rem] lg:text-[1rem]"
    >
      <i class="icon_new icon_coin !text-[1.2rem] lg:!text-[1rem]"></i>
      <span>{{ raffle.prize.item.priceUsd }}</span>
    </div>
  </div>
</div>
